<div class="auth-page">
  <div class="auth-card">
    <!-- Logo (mobile/tablet only) -->
    @if (screenType !== 'MONITOR') {
      <div class="auth-logo">
        <img src="/assets/logo-small.png" alt="Logo" />
      </div>
    }

    <div class="auth-header">
      <div class="auth-icon">
        <i class="pi pi-key"></i>
      </div>
      <h2>Reset your password</h2>
      <p>Choose a new password for your account</p>
    </div>

    @if (error) {
      <p-message severity="error" [text]="error"></p-message>
    }

    <form [formGroup]="resetForm" (ngSubmit)="reset()">
      <div class="auth-field">
        <label>New Password</label>
        <p-password
          [feedback]="false"
          [toggleMask]="true"
          [style]="{ width: '100%' }"
          [inputStyle]="{ width: '100%' }"
          formControlName="new_password"
          placeholder="Minimum 8 characters"
        ></p-password>
        @if (
          resetForm.controls['new_password'].invalid &&
          (resetForm.controls['new_password'].touched || resetForm.controls['new_password'].dirty)
        ) {
          <small class="field-error">Password must be at least 8 characters.</small>
        }
      </div>

      <div class="auth-field">
        <label>Confirm Password</label>
        <p-password
          [feedback]="false"
          [toggleMask]="true"
          [style]="{ width: '100%' }"
          [inputStyle]="{ width: '100%' }"
          formControlName="confirm_password"
          placeholder="Re-enter your password"
        ></p-password>
        @if (
          resetForm.controls['confirm_password'].invalid &&
          (resetForm.controls['confirm_password'].touched ||
            resetForm.controls['confirm_password'].dirty)
        ) {
          <small class="field-error">Passwords do not match.</small>
        }
      </div>

      <button
        type="submit"
        class="btn btn-primary auth-submit-btn"
        [disabled]="resetForm.invalid || (isLoading$ | async) === true"
      >
        @if ((isLoading$ | async) === true) {
          <span class="spinner-border spinner-border-sm me-2"></span>
        }
        Reset Password
      </button>
    </form>
  </div>
</div>
